module.exports = __webpack_public_path__ + "img/success.481b729e.svg";